import React, { useCallback } from 'react';
import { PdfPreviewDialog } from './PdfPreviewDialog';
import { useAdminData } from '../../contexts/AdminDataContext';
import { invoiceFileName, invoicePdfBytes } from '../../utils/invoicePdf';
import type { Invoice } from '../../types/invoice';
interface Props {
  invoice: Invoice;
  onClose: () => void;
}

/** Viser den færdige faktura-PDF — præcis samme fil som download. */
export function InvoicePdfPreview({
  invoice,
  onClose
}: Props) {
  const {
    settings
  } = useAdminData();
  const build = useCallback(() => invoicePdfBytes(invoice, settings), [invoice, settings]);
  return <PdfPreviewDialog title="Faktura" fileName={invoiceFileName(invoice.invoiceNumber)} build={build} onClose={onClose} data-id="element-318" data-mp="12bn6nqo9tx8o" />;
}